import type {
  GetApiV1ThreeLetterCodePartnerAdminsClientsClientId200,
  GetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions200,
  GetApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlags200,
} from '@fukuri-admins/apis/client/gen/model';
import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import {
  useGetCustomFieldDefinitions,
  useGetPartnerAdminsClient,
  useGetPartnerAdminsPartnerFeatureFlags,
} from '~/hooks';

type IUseClientDetail = (id: number) => {
  state: {
    data: GetApiV1ThreeLetterCodePartnerAdminsClientsClientId200;
    customFieldDefinitions: GetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions200;
    partnerFeatureFlags: GetApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlags200;
  };
};

/**
 * クライアント詳細のコンポーネントフック
 *
 * @param id - クライアントID（Screen 層でパース・検証済みの数値）
 */
export const useClientDetail: IUseClientDetail = id => {
  const threeLetterCode = getThreeLetterCode();

  const { data } = useGetPartnerAdminsClient({
    threeLetterCode,
    clientId: id,
  });

  const { data: partnerFeatureFlags } = useGetPartnerAdminsPartnerFeatureFlags({
    threeLetterCode,
  });

  const { data: customFieldDefinitions } = useGetCustomFieldDefinitions({
    threeLetterCode,
    target: 'c',
  });

  return {
    state: {
      data,
      customFieldDefinitions,
      partnerFeatureFlags,
    },
  };
};
